export default __webpack_public_path__ + "static/media/fonts/microsoft-teams.c859749f.svg";